import React, { useState } from 'react'
import SectionHeader from '../Faq/SectionHeader'
import FormInput from '../../Input'
import DefaultButton from '../../Button/Button'
import { useFormik } from 'formik'
import { sendMessageSchema } from '../../../validations/sendMessage'
import ContactService from '../../../api/contact-service'

const SendMessage = () => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitSuccess, setSubmitSuccess] = useState<string | null>(null)
  const [submitError, setSubmitError] = useState<string | null>(null)

  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
      message: '',
      to: '',
    },
    validationSchema: sendMessageSchema,
    onSubmit: async (values, { resetForm }) => {
      if (isSubmitting) return

      setSubmitSuccess(null)
      setSubmitError(null)
      setIsSubmitting(true)

      try {
        const res = await ContactService.sendMessage({
          name: values.name,
          email: values.email,
          message: values.message,
          to: 'safelto.app@gmail.com',
        })
        setSubmitSuccess(res.message || 'Message sent successfully!')
        resetForm()
      } catch (err: any) {
        setSubmitError(err.message || 'Failed to send message.')
      } finally {
        setIsSubmitting(false)
      }
    },
  })

  return (
    <div className=" mx-auto md:px-8 -mt-12">
      <div className='text-center'>
        <SectionHeader
          subtitle="Send a Message"
          description=""
          subTitleStyle="text-[22px] md:text-[40px] font-normal"
          descriptionStyle="text-[13px] md:text-lg"
        />
      </div>

      <div className="w-full md:max-w-[78rem] mt-6 ">
        <form onSubmit={formik.handleSubmit}>
          <div className="grid grid-cols-2 gap-6 mb-10">
            <FormInput
              type="text"
              placeholder="Full name"
              name="name"
              size="lg"
              value={formik.values.name}
              onChange={formik.handleChange}
              error={formik.touched.name ? formik.errors.name : undefined}
            />
            <FormInput
              type="email"
              placeholder="Email address"
              name="email"
              size="lg"
              value={formik.values.email}
              onChange={formik.handleChange}
              error={formik.touched.email ? formik.errors.email : undefined}
              focusBorderColor="black"
            />
            <textarea
              name="message"
              placeholder="Leave us a message"
              rows={5}
              value={formik.values.message}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="resize-none border border-solid col-span-2 rounded-md p-4"
            />
            {formik.touched.message && formik.errors.message && (
              <div className="col-span-2 text-red-500 text-sm">
                {formik.errors.message}
              </div>
            )}
          </div>
          {/* success / error messages */}
          {submitSuccess && <p className="text-green-600 mb-4">{submitSuccess}</p>}
          {submitError && <p className="text-red-600 mb-4">{submitError}</p>}

          <DefaultButton
            className="w-full"
            type="submit"
            loading={isSubmitting}
            loadingText="Submitting..."
            disabled={isSubmitting}
          >
            Send message
          </DefaultButton>
        </form>
      </div>
    </div>
  )
}

export default SendMessage
